// pages/MotDePasseOubliePage.jsx
// Mot de passe oublié, écran 1 : saisie de l'e-mail. Le message est toujours le même, que
// l'adresse existe ou non. Le lien reçu par e-mail ouvre NouveauMotDePassePage.

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BookOpen } from 'lucide-react';
import { envoyerAuth, langueInterface, messageErreurOubli } from '../utils/authOubli';
import './AuthPages.css';

export default function MotDePasseOubliePage() {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState('');
  const [erreur, setErreur] = useState('');
  const [termine, setTermine] = useState(false);
  const [enCours, setEnCours] = useState(false);

  const soumettre = async (e) => {
    e.preventDefault();
    setErreur('');
    setEnCours(true);
    const rep = await envoyerAuth('/api/auth/mot-de-passe-oublie', { email, langue: langueInterface(i18n) });
    setEnCours(false);
    if (rep.ok) setTermine(true); else setErreur(messageErreurOubli(t, rep.code));
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <BookOpen size={40} color="#4F46E5" />
          <h1>VocaVerb</h1>
          <p>{t('auth.oubliSubtitle')}</p>
        </div>

        {erreur && <div className="auth-error">{erreur}</div>}

        {termine ? (
          <div className="auth-success">{t('auth.oubliEnvoye')}</div>
        ) : (
          <form onSubmit={soumettre} className="auth-form">
            <div className="form-group">
              <label htmlFor="email">{t('auth.email')}</label>
              <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t('auth.emailPlaceholder')} required autoComplete="email" />
            </div>
            <button type="submit" className="auth-submit" disabled={enCours}>{t('auth.envoyerLien')}</button>
          </form>
        )}

        <div className="auth-footer">
          <p><Link to="/login">{t('auth.retourConnexion')}</Link></p>
        </div>
      </div>
    </div>
  );
}
